module.exports = __webpack_public_path__ + "img/face.fc525393.jpg";